export { default as StudentDetail } from "./StudentDetail";
export { default as StudentList } from "./StudentList";

